module.exports = __webpack_public_path__ + "static/images/nine.vi2d_Pi.svg";